'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.showSection = function (section) {
	return this.each(function () {
		const element = this;
		element.trigger(mmWidgets.Event('showSection', {section: section}));
	});
};

mmWidgets.fn.hasSection = function (section) {
	const widget = this;
	return !!(widget.find('[data-mm-section~="' + section + '"]').length);
};

mmWidgets.fn.backupSections = function (skip) {
	return mmWidgets.each(this, function () {
		const element = this,
			paramsSkip = skip || 1;
		element.trigger(mmWidgets.Event('backToPreviousSection', {skip: paramsSkip}));
	});

};

mmWidgets.fn.sectionHandlerWidget = function () {
	return mmWidgets.each(this, function () {
		let breadcrumbs = [];
		const element = this,
			initialSection = element.attr('data-mm-initial-section') || 'initial',
			displaySection = function (section, isGoingBack) {
				if (!isGoingBack && (breadcrumbs.length === 0 || breadcrumbs[0] !== section)) {
					breadcrumbs = [section].concat(breadcrumbs);
				}
				element.find('[data-mm-section]').addClass('hidden');
				if (section) {
					element.find('[data-mm-section~="' + section + '"]').removeClass('hidden').find('[data-mm-request-focus]').focus();
					element.find('[data-mm-section~="' + section + '"][data-mm-request-focus]').focus();
				}
			},
			showSection = function (evt) {
				const section = (evt && evt.section) || initialSection;
				if (section && this.isTarget(evt)) {
					displaySection(section);
				}
			},
			backToPreviousSection = function (evt) {
				const sectionSkip = breadcrumbs && breadcrumbs.length && Math.min((evt && evt.skip) || 1, breadcrumbs.length - 1),
					backSection = sectionSkip && breadcrumbs[sectionSkip];
				if (!backSection) {
					return;
				}
				breadcrumbs = breadcrumbs.slice(sectionSkip);
				displaySection(backSection, true);
			};
		element.on('showSection', showSection);
		element.on('hide', function () {
			breadcrumbs = [];
		});
		element.find('[data-mm-show-section]').click(function (evt) {
			const button = mmWidgets(this),
				section = button.attr('data-mm-show-section') || initialSection;
			evt.stopPropagation();
			if (button.hasClass('disabled')) {
				return;
			}
			element.showSection(section);

		});

		element.find('[data-mm-show-section-back]').click(backToPreviousSection);
		element.on('backToPreviousSection', backToPreviousSection);
	});

};

